/* eslint-disable */

import Vue from "vue";
import App from "./App.vue";

import "./assets/css/common.less";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import "devexpress-diagram/dist/dx-diagram.css";

import dataV from "@jiaminghi/data-view";
import Enum from "./enum/enum.js";

// 表格组件
import "xe-utils";
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
Vue.prototype.$XModal = VXETable.modal;

// 自定义全局的格式化处理函数
VXETable.formats.mixin({
  formatAlarmType({ cellValue }) {
    return Enum.alarmType.getLabel(cellValue);
  },
  formatLifeCycleType({ cellValue }) {
    return Enum.manifestLifeCycle.getLabel(cellValue);
  },
  // 格式化性别
  formatSex({ cellValue }) {
    return cellValue ? (cellValue === '1' ? '男' : '女') : ''
  },
  // 格式化下拉选项
  formatSelect({ cellValue }, list) {
    const item = list.find(item => item.value === cellValue)
    return item ? item.label : ''
  },
  // 格式化日期，默认 yyyy-MM-dd HH:mm:ss
  formatDate({ cellValue }, format) {
    return XEUtils.toDateString(cellValue, format || 'yyyy-MM-dd HH:mm:ss')
  },
  // 四舍五入金额，每隔3位逗号分隔，默认2位数
  formatAmount({ cellValue }, digits = 2) {
    return XEUtils.commafy(XEUtils.toNumber(cellValue), { digits })
  },
  // 格式化银行卡，默认每4位空格隔开
  formatBankcard({ cellValue }) {
    return XEUtils.commafy(XEUtils.toValueString(cellValue), { spaceNumber: 4, separator: ' ' })
  },
  // 四舍五入,默认两位数
  formatFixedNumber({ cellValue }, digits = 2) {
    return XEUtils.toFixed(XEUtils.round(cellValue, digits), digits)
  },
  // 向下舍入,默认两位数
  formatCutNumber({ cellValue }, digits = 2) {
    return XEUtils.toFixed(XEUtils.floor(cellValue, digits), digits)
  }
})


// http
import axios from "./api/index";
Vue.prototype.$axios = axios;

// api
import api from "./api/api";
Vue.prototype.$api = api;

import router from "./router";

//消息推送
import connectionSignalR from "./components/js/signalR.js";
Vue.prototype.$signalR = connectionSignalR;

Vue.config.productionTip = false;

Vue.use(dataV);
Vue.use(VXETable);
// Vue.use(SuperFlow);

new Vue({
  render: h => h(App),
  router: router
}).$mount("#app");
